/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Source from './icon-lead-stage-goal.svg';

type Props = {
    fill?: string,
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} color={validProps.fill || '#7A7370'} />;
}
SvgComponent.iconName = 'goalLeadStage';

export const GoalLeadStageIcon = svgIconWrapper(SvgComponent);
